module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"score":"Score","worst":"Worst","worse":"Worse","bad":"Bad","good":"Good"},"de":{"score":"Ergebnis","worst":"Sehr schlecht","worse":"Ziemlich schlecht","bad":"Schlecht","good":"Gut"}}')
  delete Component.options._Ctor
}
